import styled from 'styled-components';
import { Input } from 'antd';

export const InputStyled = styled(Input)`
  .ant-input:focus {
    border-color: black;
  }
`;
